import React from 'react';

export default class PortalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Portal Error:', error, info);
  }

  handleReload = () => {
    // Clear service worker caches before reload
    if ('caches' in window) {
      caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
    }
    window.location.reload();
  };

  handleLogout = () => {
    localStorage.removeItem('portalToken');
    localStorage.removeItem('portalMember');
    if ('caches' in window) {
      caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
    }
    window.location.href = '/portal/login';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#050505',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          fontFamily: 'system-ui, sans-serif',
        }}>
          <img
            src="/cobra-logo-circle.png"
            alt="Cobra Thai"
            style={{ width: 56, height: 56, borderRadius: '50%', marginBottom: 20, objectFit: 'cover' }}
          />
          <h2 style={{ color: '#fff', fontSize: 18, fontWeight: 600, marginBottom: 8, textAlign: 'center' }}>
            Something went wrong
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14, textAlign: 'center', marginBottom: 24, maxWidth: 280 }}>
            The page failed to load. Please try reloading.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '12px 32px',
              background: '#dc2626',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
              marginBottom: 12,
            }}
          >
            Reload Page
          </button>
          <button
            onClick={this.handleLogout}
            style={{
              padding: '8px 20px',
              background: 'transparent',
              color: 'rgba(255,255,255,0.3)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 8,
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            Log Out &amp; Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
